import * as Popover from '@radix-ui/react-popover';
import React, { useEffect, useState } from 'react';
import { useLocale } from '@/hooks/useLocale';
import { ILocales } from '@/interfaces/locales.interfaces';
import classNames from '@/lib/classNames';
import { hasLocaleSet } from '@/lib/hasLocaleSet';
import { LocaleSelectorContent } from './LocaleSelectorContent';
import { LocaleSelectorPopoverBackdrop } from './LocaleSelectorPopoverBackdrop';

export type LocaleSelectorPopoverProps = {
    children: React.ReactNode;
};

export const LocaleSelectorPopover = ({ children }: LocaleSelectorPopoverProps) => {
    const [currentLocale, setLocale] = useLocale();
    const [open, setOpen] = useState(!hasLocaleSet());
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    const handleOpenChange = () => {
        setOpen(false);
        if (!hasLocaleSet()) {
            setLocale(currentLocale as ILocales)
                .then()
                .catch();
        }
    };

    return (
        <Popover.Root open={open} onOpenChange={handleOpenChange} modal>
            <Popover.Trigger asChild>{children}</Popover.Trigger>
            {mounted ? (
                <Popover.Portal>
                    <div>
                        <LocaleSelectorPopoverBackdrop />
                        <Popover.Content className={classNames('z-50 w-[420px] max-w-[92vw] rounded-2xl bg-white p-6 text-primary shadow-xl outline-none animate-in')}>
                            <Popover.Close className="absolute top-2 right-2 inline-flex h-8 w-8 items-center justify-center rounded-full text-primary/70 hover:bg-black/5 hover:text-primary outline-none">
                                x
                            </Popover.Close>
                            <LocaleSelectorContent onChange={() => setOpen(false)}>Change your travel destination here</LocaleSelectorContent>
                            <Popover.Arrow fill="#fff" />
                        </Popover.Content>
                    </div>
                </Popover.Portal>
            ) : null}
        </Popover.Root>
    );
};
